"use client";

import styles from "./styles.module.scss";
import DegreeProgramCard from "@molecules/DegreeProgramCard/DegreeProgramCard";
import Image from "next/image";
import { useCallback, useEffect, useRef, useState } from "react";
import cn from "clsx";
import ProgramFiltersMenu from "../ProgramFiltersMenu/ProgramFiltersMenu";
import useOnScreen from "@/helpers/Onscreen";

const ImagesList = [
  { src: "/_a/icons/programListing/hat.png", alt: "filter-by-program-type" },
  { src: "/_a/icons/programListing/document.png", alt: "filter-by-domain" },
  { src: "/_a/icons/programListing/history.png", alt: "filter-by-duration" },
  { src: "/_a/icons/programListing/trending.png", alt: "filter-by-trending-programs" },
];

export default function ProgramsWithFilter({
  programs,
  filteredPrograms,
  isDesktop,
  toggleFilters,
  isFiltersOpen,
  setFilteredPrograms,
  setIsFiltersApplied,
  isFiltersApplied,
  isProgramSpecific = false,
  setPreviousPrograms,
  setQuery,
  query,
  isCertification = false,
  domain = "",
  offeredBy = ""
}) {

  const [displayedPrograms, setDisplayedPrograms] = useState([]);
  const programCardRef = useRef(null);
  const visibleRef = useRef(null);
  const onScreen = useOnScreen(visibleRef);

  useEffect(() => {
    if (filteredPrograms.length !== displayedPrograms.length) {
      const newDisplayedPrograms = isDesktop
        ? filteredPrograms?.slice(0, displayedPrograms?.length + 6)
        : filteredPrograms?.slice(0, displayedPrograms?.length + 4);
      setDisplayedPrograms(newDisplayedPrograms);
    }
  }, [onScreen]);

  useEffect(() => {
    setDisplayedPrograms(isDesktop ? filteredPrograms?.slice(0, 6) : filteredPrograms?.slice(0, 4));
  }, [filteredPrograms]);

  return (
    <>
    <div className={styles.programsRoot}>
      <div
        className={cn(styles.filtersDesktop, {
          ["!max-w-0 !opacity-0 !p-0 !h-0"]: !isFiltersOpen || !isDesktop,
        })}
      >
        <ProgramFiltersMenu
          programs={programs}
          toggleFilters={toggleFilters}
          setFilteredPrograms={setFilteredPrograms}
          setIsFiltersApplied={setIsFiltersApplied}
          isProgramSpecific={isProgramSpecific}
          setPreviousPrograms={setPreviousPrograms}
          query={query}
          setQuery={setQuery}
          domain={domain}
          offeredBy={offeredBy}
        />
      </div>
      <div
        className={cn(styles.filterTypes, {
          ["!hidden"]: isFiltersOpen,
        })}
      >
        <div
          className={cn("w-fit mx-auto", {
            [styles.activeFilters]: isFiltersApplied && isDesktop,
          })}
        >
          <Image
            src="/_a/icons/programListing/filter.svg"
            alt="Apply Filters"
            onClick={toggleFilters}
            width={30}
            height={30}
            className="cursor-pointer"
          />
        </div>
        {ImagesList.map((image, i) => (
          <Image src={image?.src} alt={image?.alt || ""} onClick={toggleFilters} key={i} width={10} height={10} />
        ))}
      </div>
      <div className={styles.programCount}>
        <p
          className={cn(styles.count, {
            ["!px-0"]: isFiltersOpen && isDesktop,
          })}
        >
          {`Showing ${
            filteredPrograms.length
          } ${
            displayedPrograms?.length === 1 || displayedPrograms?.length === 0
              ? isCertification ? "Certification Program" : "Program"
              : isCertification ?  "Certification Programs" : "Programs"
          }`}
        </p>
        <div
          className={cn(styles.programsContainer, {
            ["!grid-cols-2"]: isFiltersOpen && isDesktop,
          })}
          ref={programCardRef}
        >
          {displayedPrograms?.map((item, i) => (
            <DegreeProgramCard card_index={i} key={i} {...item?.attributes?.BasicDetails} isSmall scroll />
          ))}
        </div>
      </div>
    </div>
    <div ref={visibleRef}>.</div>
  </>  
  );
}
